const gfWrap = document.querySelector('.gift-flow-wrap');
if(gfWrap){
let gfNextBtn = document.querySelector('#gc-next-btn:not(.disabled)');
const gfContents = document.querySelectorAll('.gf-c');
const gfGCItemBtns = document.querySelectorAll('.gf-gc-item');
const gfGCItemFrees = document.querySelectorAll('.gf-gc-list-free li');
let gfSelect = document.querySelector('#gf-occ');
const gfName = document.querySelector('.gf-form-inner input');
const gfMess = document.querySelector('.gf-form-inner textarea');
const gfSend = document.querySelector('.gf-form-inner .gf-form-input-sender');
const gfOccErr = document.querySelector('.gf-occ-err');
const gfMessErr = document.querySelector('.gf-mess-err');
const gfReviewCover = document.querySelector('.gf-summary-tabs-gc-cover');
const gfReviewPvw = document.querySelector('.gf-summary-tabs-gc-pvw');
const gfReviewSumm = document.querySelector('.gf-summ-texts');
const gfReviewSummItems = document.querySelectorAll('.gf-summary-title');
const itemCountText = document.querySelector('.gf-summ-items-heading span');
const gfSummItemGC = document.querySelector('.gf-summ-item-gc');
let gfSummItemPack = document.querySelector('.gf-summ-item-pack');
const gfBackBtn = document.querySelector('.gf-back');   
const dotSpinner = document.querySelector('.dud-dot-spinner');  
// const dataBox = document.querySelector('#data-box');
let nextNum = 2;
let items = '';
// let gfNextBtn = document.querySelector('[data-next="2"]');

let self, step3, checkoutBtn;
let occChanged = false;
let gfGCItemBtnClicked,gcAdded,packAdded =  false;


let giftData = {
  occassion: "",
  giftCardId: "",
  recName: "",
  message: "",
  sendName: ""
}
const showEl = (el) => el.classList.remove('rdc-d-none');
const hideEl = (el) => el.classList.add('rdc-d-none');  
let formIncomplete = (gfName.value == '' || gfMess.value == '' || gfSend.value == '');  

const activateDotSpinner = function (whereToShow,timeToHide) {
  whereToShow.appendChild(dotSpinner);
  showEl(dotSpinner);
  setTimeout(function () {
    hideEl(dotSpinner);
  },timeToHide)
}  
  
const hideShowBack = function () {
  if(gfNextBtn.getAttribute('data-next') == '2') {
  hideEl(gfBackBtn);
} else {
  showEl(gfBackBtn);
}
} 
  
const removeGC = function () {
let removeItemId,updates;

   fetch(window.Shopify.routes.root + 'cart.js', {
  method: 'GET'})
  .then((response) => response.json())
  .then((data) => {
    data.items.forEach(dataItem => {
      if(dataItem.product_title.includes('Greeting Card')) {
        removeItemId = dataItem.id;
      }
    })
    
    updates = {[removeItemId]: 0}

    if(removeItemId !== undefined) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({ updates })
})
.then(response => {return response.json()})
.then(data => {console.log(data)})      
.catch((error) => {console.error('Error:', error)});
}
  
});
}
// removeGC();
const goBack = function () {

   nextNum--;
  gfContents.forEach(gfContent => {
    gfContent.classList.add('rdc-d-none');
    if(Number(gfContent.getAttribute('data-curr')) == nextNum-1) {
      gfContent.classList.remove('rdc-d-none');
    }
  })
   gfNextBtn.setAttribute('data-next',`${nextNum}`);
    gfNextBtn.innerText = `STEP ${nextNum}`;
    hideShowBack();
}

const updateProgress = function () {
gfSelect = document.querySelector('#gf-occ');
addOccToData();
// Update progress  
  if(nextNum < 6) {

//Ensure an occasion is selected
if((document.querySelector('[data-next="3"]') && gfSelect[gfSelect.selectedIndex].text == 'Select')) {
  gfOccErr.classList.remove('rdc-d-none');
    
} 
else if((document.querySelector('[data-next="5"]') && formIncomplete)) {
  gfMessErr.classList.remove('rdc-d-none');
}
else {

  gfOccErr.classList.add('rdc-d-none');
  gfMessErr.classList.add('rdc-d-none');
  
// Update content
   gfContents.forEach(gfContent => {
    gfContent.classList.add('rdc-d-none');
    if(Number(gfContent.getAttribute('data-curr')) == nextNum) {
      gfContent.classList.remove('rdc-d-none');
    }
  })
   nextNum++
    self.setAttribute('data-next',`${nextNum}`);
    self.innerText = `STEP ${nextNum}`;

  if(!gfGCItemBtnClicked) {
    gfGCItemFrees.forEach(gfGCItemFree => {
      formIncomplete = (gfName.value == '' || gfMess.value == '' || gfSend.value == ''); 
    if(gfGCItemFree.querySelector('.gc-title').innerText == gfSelect[gfSelect.selectedIndex].text) {
      gfGCItemFree.querySelector('.gf-img-inner').classList.add('rdc-selected');
      giftData.giftCardId = `${gfGCItemFree.getAttribute('data-id')}`;
    }
  })
  }
//   if(document.querySelector('[data-next="5"]')) {
//   removeGC();
// }
}
}
 
  if(nextNum == 6) {
    self.innerText = 'CHECKOUT';
  }
  hideShowBack();
}
const checkout = function () {
  if(self.getAttribute('data-next') == '6') {
    location.replace("/checkout");
  }
}
const addOccToData = function () {
  // self = this;
  giftData.occassion = `${gfSelect[gfSelect.selectedIndex].text}`;

  gfGCItemFrees.forEach(gfGCItemFree => {
    gfGCItemFree.classList.add('rdc-d-none');
    if(gfGCItemFree.querySelector('.gc-title').innerText == giftData.occassion) {
      gfGCItemFree.classList.remove('rdc-d-none');
      // Update Review Section
      gfReviewCover.innerHTML = `<img class="rdc-w-full" src="${gfGCItemFree.querySelector('.gf-img-inner').getAttribute('data-cover')}">`
      gfReviewPvw.innerHTML = `<img class="rdc-w-full" src="${gfGCItemFree.querySelector('.gf-img-inner').getAttribute('data-pvw')}">`
    }
  })
}

const addGcToData = function () {
  self = this;
  gfGCItemBtnClicked = true;

  gfGCItemBtns.forEach(gfGCItemBtn => gfGCItemBtn.querySelector('.gf-img-inner').classList.remove('rdc-selected'));
  self.querySelector('.gf-img-inner').classList.add('rdc-selected');
  giftData.giftCardId = `${self.getAttribute('data-id')}`;
}
const addMessToData = function () {
  gfSummItemPack = document.querySelector('.gf-summ-item-pack');
  let totalAmount = 0;
  self = this;
formIncomplete = (gfName.value == '' || gfMess.value == '' || gfSend.value == ''); 
  if((self.getAttribute('data-next') == '5') && !formIncomplete) {

    
    // checkoutBtn = document.querySelector('[data-next="5"]');
    giftData.recName = `${gfName.value}`;
    giftData.message = `${gfMess.value}`;
    giftData.sendName = `${gfSend.value}`;
 
  gfReviewSumm.innerHTML = `<div class="gf-summ-text-line"><strong>Recipient's name:</strong> ${giftData.recName}</div>
  <div class="gf-summ-text-line"><strong>Message:</strong> ${giftData.message}</div>
  <div class="gf-summ-text-line"><strong>Sender's name:</strong> ${giftData.sendName}</div>`

    
let gcData = {
 'items': [{
  'id': giftData.giftCardId,
  'quantity': 1,
   'properties': {
     'Recipient': `${giftData.recName}`,
     'Message': `${giftData.message}`,
     'Sender': `${giftData.sendName}`
   }
  }]
};



// setTimeout(function () {    
// fetch(window.Shopify.routes.root + 'cart/change.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify({'id': '42896373252189','quantity': 0})
// })

  
// .then(response => {return response.json()})
//  .then((data) => {console.log(data)})  
// .catch((error) => {console.error('Error:', error)}); 
 
// },2000)  
// //
fetch(window.Shopify.routes.root + 'cart.js', {
  method: 'GET'})
  .then((response) => response.json())
  .then((data) => {
    let toBeDeleted;
    let gcCount = 0;
    data.items.forEach(dataItem => {
      if(dataItem.product_title.includes('GIFT Packaging')) {
        gcCount++;
      if(dataItem.id == giftData.giftCardId) {
         gcAdded = true;
      } else {
       toBeDeleted = {'id': `${dataItem.id}`,'quantity': 0}
      }
};  
      if(dataItem.id == 43020245499997) {
        packAdded = true;
      }
});  
 setTimeout(function () {     
if(!packAdded) {
  let packData = {
 'items': [{
  'id': 43020245499997,
  'quantity': 1
  }]
};
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(packData)
})
.then(response => {
  return response.json()})
.catch((error) => {console.error('Error:', error)});
  
}    
 },2000)
if(!gcAdded) {
  
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(gcData)
})
.then(response => {
  return response.json()})
.catch((error) => {console.error('Error:', error)});

 if(gcCount > 0) { 
setTimeout(function () {  
fetch(window.Shopify.routes.root + 'cart/change.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(toBeDeleted)
})
.then(response => {return response.json()})
 .then((data) => {console.log(data)})  
.catch((error) => {console.error('Error:', error)}); 
 
},2000)  
 }

} else {
  setTimeout(function () {  
  let gcDataUpdateMess = {
  'id': `${giftData.giftCardId}`,
  'quantity': 1,
   'properties': {
     'Recipient': `${giftData.recName}`,
     'Message': `${giftData.message}`,
     'Sender': `${giftData.sendName}`
   }

};    
fetch(window.Shopify.routes.root + 'cart/change.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(gcDataUpdateMess)
})
.then(response => {return response.json()})
 .then((data) => {console.log(data)})  
.catch((error) => {console.error('Error:', error)}); 
 
},2000)  
}


})

   
setTimeout(function () {
   fetch(window.Shopify.routes.root + 'cart.js', {
  method: 'GET'})
  .then((response) => response.json())
  .then((data) => {
          let occType = '';
      let optionsHTML = '';
    totalAmount = data.total_price * .01;
    totalAmount = totalAmount.toFixed(2);
    totalAmount = totalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
     let regItems = '';
    let regItemsCont = document.querySelector('.gf-summary-reg-items');
    // const regItemCount = document.querySelector('.gf-summ-qty-count');
    data.items.forEach(dataItem => {
      const optionHTMLFunc = function () {
        optionsHTML = '';
      dataItem.options_with_values.forEach(option => {
        optionsHTML = optionsHTML.concat(`<div class="product-option">
                  <span>${option.name}: </span>
                  <span>${option.value}</span>
                </div>`);
      })
      }
      
        
      let dataPrice = dataItem.price == 0 ? 'FREE' : (dataItem.price * .01);
      if(dataItem.product_title.includes('Greeting Card')) {
          occType = dataItem.variant_title;
        optionHTMLFunc();
        gfSummItemGC.innerHTML = `<div class="gf-summ-tabs-item-img rdc-d-flex">
              <img src="${dataItem.image}" width="100%" height="auto">
            </div>
            <div>
              <p class="gf-summary-title" data-qty="${dataItem.quantity}">${dataItem.product_title}</p>
              <p>${dataPrice > 0 ? '₱' : ''} ${dataPrice}</p>
                ${optionsHTML}
            </div>`
      } else if (dataItem.product_title.includes('Packaging')) {
        optionHTMLFunc();
        gfSummItemPack.innerHTML = `<div class="gf-summ-tabs-item-img rdc-d-flex">
              <img src="${dataItem.image}" width="100%" height="auto">
            </div>
            <div>
              <p class="gf-summary-title" data-qty="${dataItem.quantity}">${dataItem.product_title}</p>
              <p>₱ ${dataItem.price * .01}</p>
            </div>`
      } else {
        optionHTMLFunc();
        let regItem = `<div class="gf-summary-tabs-item rdc-d-flex rdc-m-b10">
            <div class="gf-summ-tabs-item-img rdc-d-flex">
              <img src="${dataItem.image}" width="100%" height="auto">
            </div>
            <div>
              <p class="gf-summary-title" data-qty="${dataItem.quantity}">${dataItem.product_title}</p>
              <p>${dataPrice > 0 ? '₱' : ''} ${dataPrice}</p>
               ${optionsHTML}
               <div class="gf-summ-qty"><span>Quantity: <span class="gf-summ-qty-count">${dataItem.quantity}</span></span></div>
                </div></div>`;
        regItems = regItems.concat(`${regItem}`)
       
        // regItemCount.innerText = `${dataItem.quantity}`;
        regItemsCont.innerHTML = regItems;
      }
    })

  
    itemCountText.innerText = `(${data.item_count}) - ₱${totalAmount}`;
});
},5000)    
activateDotSpinner(document.querySelector('.gf-summary-main'),5000);
 
}
}
setTimeout(function () {
   fetch(window.Shopify.routes.root + 'cart.js', {
  method: 'GET'})
  .then((response) => response.json())
  .then((data) => {
    console.log(data);
});
},1000)  

const giftFlow = function () {
  self = this;
  updateProgress();
}


if(gfNextBtn) {
gfNextBtn.addEventListener('click',addMessToData);
gfNextBtn.addEventListener('click',checkout);
gfNextBtn.addEventListener('click',giftFlow);
gfBackBtn.addEventListener('click',goBack);
}
// gfSelect.addEventListener('change',addOccToData);
gfGCItemBtns.forEach(gfGCItemBtn => gfGCItemBtn.addEventListener('click',addGcToData));


//Open and close the box
const gfCloseFuncs = document.querySelectorAll('.gf-close-func');
let gfOpenFuncs = document.querySelectorAll('.gf-open-func');
const gfToggleConts = document.querySelectorAll('.gf-toggle-c');
const atcButton = document.querySelector('.product-form__submit');
  

// let cartCountText,gfNoItemText,gfBody;
const gfNoItemText = document.querySelector('.gf-no-cart-item');   
const gfBody = document.querySelector('.gift-flow-body');   
  

const closeGF = function () {
  gfWrap.classList.add('rdc-d-none');
}
const openGF = function () { 
hideShowBack();
showEl(dotSpinner);
setTimeout(function () {
  gfOpenFuncs = document.querySelectorAll('.gf-open-func');
  const cartCountText = document.querySelector('.cart-count-bubble span:first-child'); 
    gfToggleConts.forEach(gfToggleCont => {
      gfToggleCont.classList.add('rdc-d-none');
      if(Number(cartCountText.innerText) > 0) {
        gfBody.classList.remove('rdc-d-none');
      } else {
        gfNoItemText.classList.remove('rdc-d-none');
      }
    })
        gfWrap.classList.remove('rdc-d-none');
  hideEl(dotSpinner);
    gfOpenFuncs.forEach(gfOpenFunc => gfOpenFunc.addEventListener('click',openGF));
},2000)

}
const activateGFBanner = function () {
  setTimeout(function () {
     gfOpenFuncs = document.querySelectorAll('.gf-open-func');
  gfOpenFuncs.forEach(gfOpenFunc => gfOpenFunc.addEventListener('click',openGF));
  },2000)
}

if(atcButton)atcButton.addEventListener('click',activateGFBanner);
gfCloseFuncs.forEach(gfCloseFunc => gfCloseFunc.addEventListener('click',closeGF));
gfOpenFuncs.forEach(gfOpenFunc => gfOpenFunc.addEventListener('click',openGF));
}





